'use client';

import { m, useReducedMotion } from 'motion/react';
import { useContext, type ReactNode } from 'react';

import { NavItemCollapsingContext } from './nav-item-collapsing-context';

/**
 * Wraps children in a height-collapse exit animation when the parent
 * PrimaryNavFixedItem is collapsing. Reads NavItemCollapsingContext so
 * NavItem itself stays unaware of collapse mechanics.
 */
export function NavItemCollapsingAnimation({ children }: { children: ReactNode }) {
  const isCollapsing = useContext(NavItemCollapsingContext);
  const prefersReducedMotion = useReducedMotion();

  if (!isCollapsing) return <>{children}</>;

  return (
    <m.div
      initial={{ height: 'auto', opacity: 1 }}
      animate={{ height: 0, opacity: 0 }}
      transition={
        prefersReducedMotion
          ? { duration: 0 }
          : { type: 'tween', duration: 0.18, ease: 'easeOut' }
      }
      style={{ overflow: 'hidden' }}
    >
      {children}
    </m.div>
  );
}
